import Skeleton from 'react-loading-skeleton';
import theme from '@styles/theme';
import styles from '@features/cart/components/CartPriceSkeleton/CartPriceSkeleton.styles';
type PropsType = {
  color?: string;
  width?: number;
};
const CartPriceSkeleton = ({
  color = theme.rawColors.lightGrey300,
  width = 85
}: PropsType) => <div sx={styles.cartPriceSkeletonContainer} data-cy="CartPriceSkeleton">
    <Skeleton count={1} height={22} width={width} baseColor={color} enableAnimation sx={styles.cartPriceSkeleton} />
  </div>;
export default CartPriceSkeleton;